import { useAppTranslation } from '../i18n/useAppTranslation';
import SearchOffIcon from "@mui/icons-material/SearchOff";
import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Chip,
  Stack,
  Divider,
  Avatar,
  useTheme,
  useMediaQuery,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Pagination,
  Skeleton,
} from "@mui/material";
import api, { publicApi } from "../services/api";
import SportUniverse from "../components/SportUniverse";
import "./CoachCards.css";
import PublicCoachDetails from "../components/PublicCoachDetails";
import { format } from "date-fns";

import { useNavigate, useLocation } from "react-router-dom";
import {
  AccessTime,
  Info,
  SportsScore,
  Euro,
  Chat,
  Close,
  Instagram,
  LinkedIn,
  Facebook,
  Language,
  Work,
  Star,
  LocationOn,
  Verified,
  ViewModule,
  ViewList,
  People,
  YouTube,
  Pinterest,
} from "@mui/icons-material";
import { getMediaUrl } from "../utils/imageUrl";

const TikTokIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.75a8.27 8.27 0 0 0 4.84 1.55V6.85a4.85 4.85 0 0 1-1.07-.16z" />
  </svg>
);
const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const SnapchatIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.27-.27.41-.555.41h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.873-.283-2.906-.702-3.145-1.271-.03-.076-.046-.15-.046-.225-.015-.239.165-.465.42-.509 3.264-.54 4.73-3.878 4.791-4.014l.015-.015c.18-.345.21-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.045-.24-.09-.345-.134-1.214-.54-1.124-1.199-.827-1.667.181-.301.598-.509 1.048-.509.255 0 .464.06.494.074.389.181.75.27 1.048.27.195 0 .315-.044.405-.089l-.031-.51c-.105-1.629-.225-3.651.301-4.843C7.857 1.077 11.215.807 12.206.807z" />
  </svg>
);
const WhatsAppIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);

const CoachList = ({ visitor = false, initialSport = '' }: { visitor?: boolean; initialSport?: string }) => {
  const { tr, dateLocale } = useAppTranslation();
  const directoryApi = visitor ? publicApi : api;
  const [publicCoach, setPublicCoach] = useState<any>(null);
  const registerForCoach = (coach: any) => navigate('/register', { state: { role: 'SPORTIF', sport: coach.coach_profile?.sport || initialSport, intent: 'booking', coach: { id: coach.id, username: coach.username } } });
  const navigate = useNavigate();
  const location = useLocation();
  const [coachSearch, setCoachSearch] = useState(visitor ? '' : location.state?.coach?.username || '');
  const [bookingSlotId, setBookingSlotId] = useState<number | null>(null);
  const theme = useTheme();
  const coachCardStyles = {
    borderRadius: '20px', border: '1px solid', borderColor: 'divider',
    background: theme.palette.mode === 'light' ? 'linear-gradient(135deg, #FFFFFF, #F0F8FF)' : theme.palette.background.paper,
    boxShadow: theme.palette.mode === 'light' ? '0 8px 28px #254c7310' : '0 8px 28px #0003',
    overflow: 'hidden', transition: 'border-color .2s, box-shadow .2s',
    '&:hover': { borderColor: 'primary.main', boxShadow: '0 10px 30px #0002' },
    '& .MuiTypography-subtitle1': { fontSize: '1.2rem', overflowWrap: 'anywhere' },
    '& .MuiTypography-caption': { fontSize: '.8rem', lineHeight: 1.6 },
    '& .MuiChip-root': { height: 24, fontSize: '.72rem' },
    '& .MuiButton-contained': {
      background: theme.palette.primary.main, color: theme.palette.primary.contrastText,
      border: 'none', boxShadow: 'none', minHeight: 42,
      '&:hover': { background: theme.palette.primary.dark, boxShadow: 'none' },
    },
    '& .MuiIconButton-root': { minWidth: 36, minHeight: 36 },
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [coaches, setCoaches] = useState<any[]>([]);
  const [selectedCoach, setSelectedCoach] = useState<any>(null);
  const [availabilities, setAvailabilities] = useState<any[]>([]);
  const [myBookings, setMyBookings] = useState<any[]>([]);
  const [programs, setPrograms] = useState<any[]>([]);
  const [selectedProgramId, setSelectedProgramId] = useState<number | "">("");
  const [openBooking, setOpenBooking] = useState(false);
  const [openProgramDetails, setOpenProgramDetails] = useState(false);
  const [programToView, setProgramToView] = useState<any>(null);
  const [bookingConfirmation, setBookingConfirmation] = useState<any>(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [filterSport, setFilterSport] = useState(initialSport);
  const [filterCity, setFilterCity] = useState("");
  const [sortBy, setSortBy] = useState<"rating" | "price_asc" | "price_desc">(
    "rating"
  );
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [availableSports, setAvailableSports] = useState<string[]>([]);
  const [viewMode, setViewMode] = useState<"grid" | "list">("list");
  const PAGE_SIZE = 12;

  const [loading, setLoading] = useState(true);
  const [searchError, setSearchError] = useState("");
  const [retry, setRetry] = useState(0);
  const resetFilters = () => {
    setCoachSearch('');
    setFilterCity("");
    setFilterSport("");
    setSortBy("rating");
    setPage(1);
  };

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    setLoading(true);
    setSearchError("");
    const timer = setTimeout(async () => {
      try {
        const params = new URLSearchParams({
          ordering: sortBy,
          page: String(page),
          page_size: String(PAGE_SIZE),
        });
        if (coachSearch) params.set('q', coachSearch);
        if (filterSport) params.set("sport", filterSport);
        if (filterCity.trim()) params.set("city", filterCity.trim());
        const { data } = await directoryApi.get("/users/coaches/?" + params.toString(), {
          signal: controller.signal,
        });
        if (!active) return;
        setCoaches(Array.isArray(data) ? data : data.results ?? []);
        setTotalCount(Array.isArray(data) ? data.length : data.count ?? 0);
      } catch (err: any) {
        if (active)
          setSearchError(
            err.response?.status === 401
              ? "Session expirée. Veuillez vous reconnecter."
              : "Impossible de charger les coachs. Vérifiez votre connexion et réessayez."
          );
      } finally {
        if (active) setLoading(false);
      }
    }, 300);
    return () => {
      active = false;
      clearTimeout(timer);
      controller.abort();
    };
  }, [filterSport, filterCity, sortBy, page, retry, directoryApi, coachSearch]);

  useEffect(() => {
    directoryApi
      .get("/users/sports/")
      .then((res) => setAvailableSports(res.data))
      .catch((err) =>
        console.error(
          "sports fetch error:",
          err?.response?.status,
          err?.response?.data
        )
      );
  }, [directoryApi]);

  useEffect(() => {
    if (!openBooking || !selectedCoach) return;
    const poll = setInterval(() => refreshBookings(selectedCoach), 15000);
    const onVisible = () => {
      if (document.visibilityState === "visible")
        refreshBookings(selectedCoach);
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(poll);
      document.removeEventListener("visibilitychange", onVisible);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openBooking, selectedCoach]);

  const handleViewCoach = async (coach: any) => {
    if (visitor) { setPublicCoach(coach); return; }
    setSelectedCoach(coach);
    setSelectedProgramId("");
    setError("");
    setMessage("");
    try {
      const [availRes, programsRes, bookingsRes] = await Promise.all([
        api.get(`/coaching/availabilities/?coach_id=${coach.id}`),
        api.get(`/coaching/programs/?coach_id=${coach.id}`),
        api.get(`/coaching/bookings/`),
      ]);
      setAvailabilities(availRes.data);
      setPrograms(programsRes.data);
      // Séances déjà planifiées par ce coach pour le sportif connecté
      setMyBookings(
        bookingsRes.data.filter(
          (b: any) => b.coach_details?.id === coach.id || b.coach === coach.id
        )
      );
      setOpenBooking(true);
    } catch (error: any) {
      console.error("Failed to fetch coach details", error);
      if (error.response?.status === 401) {
        setError("Session expirée. Veuillez vous reconnecter.");
      } else {
        setError("Impossible de charger les détails du coach.");
      }
    }
  };

  const refreshBookings = async (coach: any) => {
    try {
      const [bookingsRes, availRes] = await Promise.all([
        api.get("/coaching/bookings/"),
        api.get(`/coaching/availabilities/?coach_id=${coach.id}`),
      ]);
      setMyBookings(
        bookingsRes.data.filter(
          (b: any) => b.coach_details?.id === coach.id || b.coach === coach.id
        )
      );
      setAvailabilities(availRes.data);
    } catch {
      // silencieux - ne pas afficher d'erreur réseau pendant le polling
    }
  };

  const handleSportifCancel = async (bookingId: number) => {
    const booking = myBookings.find((b) => b.id === bookingId);
    const isPending = booking?.status === "PENDING";
    // Optimistic update : si PENDING → supprimer de la liste, sinon → passer en CANCELLED
    if (isPending) {
      setMyBookings((prev) => prev.filter((b) => b.id !== bookingId));
    } else {
      setMyBookings((prev) =>
        prev.map((b) =>
          b.id === bookingId ? { ...b, status: "CANCELLED" } : b
        )
      );
    }
    setMessage(
      isPending ? "Demande annulée, le créneau est libéré." : "Séance annulée."
    );
    try {
      await api.post(`/coaching/bookings/${bookingId}/cancel/`);
    } catch (e: any) {
      // Rollback
      if (isPending) {
        setMyBookings((prev) => (booking ? [...prev, booking] : prev));
      } else {
        setMyBookings((prev) =>
          prev.map((b) =>
            b.id === bookingId ? { ...b, status: booking?.status } : b
          )
        );
      }
      setMessage("");
      setError(e?.response?.data?.detail || "Erreur lors de l'annulation.");
    }
  };

  const handleOpenProgramDetails = () => {
    if (selectedProgramId) {
      const prog = programs.find((p) => p.id === selectedProgramId);
      if (prog) {
        setProgramToView(prog);
        setOpenProgramDetails(true);
      }
    }
  };

  const handleBookSession = async (availabilityId: number) => {
    // Verrou : sans lui, deux clics rapides envoyaient deux POST concurrents
    // et pouvaient creer deux reservations sur le meme creneau.
    if (bookingSlotId !== null) return;
    setBookingSlotId(availabilityId);
    try {
      const slot = availabilities.find((a) => a.id === availabilityId);
      if (!slot) return;
      await api.post("/coaching/bookings/", {
        coach: selectedCoach.id,
        start_time: slot.start_time,
        end_time: slot.end_time,
        program: selectedProgramId === "" ? null : selectedProgramId,
      });
      // Recapitulatif : rassure le sportif au moment cle (coach, date, tarif).
      const prog = programs.find((p) => p.id === selectedProgramId);
      const tarif = prog
        ? prog.price
        : selectedCoach.coach_profile?.hourly_rate;
      setBookingConfirmation({
        coachName: selectedCoach.username,
        start: slot.start_time,
        end: slot.end_time,
        programTitle: prog ? prog.title : "Séance personnalisée",
        price: tarif,
      });
      if (selectedCoach) await refreshBookings(selectedCoach);
    } catch (error: any) {
      const errorMsg =
        error.response?.data?.detail ||
        (error.response?.data?.non_field_errors
          ? error.response?.data?.non_field_errors[0]
          : null) ||
        (typeof error.response?.data === "string"
          ? error.response?.data
          : null) ||
        "Échec de la réservation.";
      setError(
        typeof errorMsg === "object" ? JSON.stringify(errorMsg) : errorMsg
      );
    } finally {
      setBookingSlotId(null);
    }
  };

  return (
    <Container sx={{ mt: isMobile ? 2 : 4, mb: 4 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          mb: 4,
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={700} color="text.primary">
             {tr("Trouvez le coach qui vous correspond 🎯")} </Typography>
          <Typography variant="body2" color="text.secondary">
             {tr("Des experts certifiés pour atteindre vos objectifs sportifs")} </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            flexWrap: "wrap",
            width: isMobile ? "100%" : "auto",
          }}
        >
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(_, v) => v && setViewMode(v)}
            size="small"
            sx={{ flexShrink: 0 }}
          >
            <ToggleButton
              value="grid"
              aria-label={tr("Vue grille")}
              title={tr("Vue grille")}
            >
              <ViewModule fontSize="small" />
            </ToggleButton>
            <ToggleButton value="list" aria-label={tr("Vue liste")} title={tr("Vue liste")}>
              <ViewList fontSize="small" />
            </ToggleButton>
          </ToggleButtonGroup>
          <TextField
            size="small"
            label={tr("Ville")}
            placeholder={tr("Ex. Paris")}
            value={filterCity}
            onChange={(e) => {
              setPage(1);
              setFilterCity(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <LocationOn
                  fontSize="small"
                  sx={{ mr: 0.5, color: "text.secondary" }}
                />
              ),
            }}
            sx={{ minWidth: isMobile ? 0 : 150, flexGrow: isMobile ? 1 : 0 }}
          />
          <FormControl
            size="small"
            sx={{ flexGrow: 1, minWidth: isMobile ? 0 : 160 }}
          >
            <InputLabel id="filter-sport-label">{tr("Sport")}</InputLabel>
            <Select
              labelId="filter-sport-label"
              value={filterSport}
              label={tr("Sport")}
              onChange={(e) => {
                setPage(1);
                setFilterSport(e.target.value);
              }}
            >
              <MenuItem value="">{tr("Tous les sports")}</MenuItem>
              {Array.from(new Set([...availableSports, ...(filterSport ? [filterSport] : [])])).map((s) => (
                <MenuItem key={s} value={s}>
                  {tr(s)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{ minWidth: isMobile ? 0 : 150, flexGrow: isMobile ? 1 : 0 }}
          >
            <InputLabel id="sort-label">{tr("Trier par")}</InputLabel>
            <Select
              labelId="sort-label"
              value={sortBy}
              label={tr("Trier par")}
              onChange={(e) => {
                setPage(1);
                setSortBy(e.target.value as typeof sortBy);
              }}
            >
              <MenuItem value="rating">{tr("Mieux notés")}</MenuItem>
              <MenuItem value="price_asc">{tr("Prix croissant")}</MenuItem>
              <MenuItem value="price_desc">{tr("Prix décroissant")}</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {tr(message)}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
          {typeof error === 'string' ? tr(error) : error}
        </Alert>
      )}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2, minHeight: 40 }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          role="status"
          aria-live="polite"
        >
          {loading
            ? tr("Recherche des coachs…")
            : searchError
            ? tr("Recherche indisponible")
            : tr(totalCount < 2 ? tr("{count} coach disponible") : tr("{count} coachs disponibles"), { count: totalCount })}
        </Typography>
        {(coachSearch || filterCity || filterSport || sortBy !== "rating") && (
          <Button size="small" onClick={resetFilters}>
             {tr("Réinitialiser les filtres")} </Button>
        )}
      </Stack>
      {loading ? (
        <Stack spacing={2} aria-label={tr("Chargement des coachs")}>
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} variant="rounded" height={160} />
          ))}
        </Stack>
      ) : searchError ? (
        <Alert
          severity="error"
          action={
            <Button color="inherit" onClick={() => setRetry((v) => v + 1)}>
               {tr("Réessayer")} </Button>
          }
        >
          {searchError}
        </Alert>
      ) : coaches.length === 0 ? (
        <Box
          sx={{
            p: { xs: 3, md: 6 },
            textAlign: "center",
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 3,
          }}
        >
          <SearchOffIcon
            sx={{ fontSize: 40, color: "text.secondary", mb: 1 }}
          />
          <Typography variant="h6">
             {tr("Aucun coach ne correspond à ces critères")} </Typography>
          <Typography color="text.secondary" sx={{ mt: 1, mb: 2 }}>
             {tr("Essayez une autre ville ou élargissez votre sélection de sports.")} </Typography>
          <Button variant="outlined" onClick={resetFilters}>
             {tr("Voir tous les coachs")} </Button>
        </Box>
      ) : viewMode === "list" ? (
        /* ── VUE LISTE ── */
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {coaches.map((coach) => (
            <Card key={coach.id} className="coach-directory-card coach-directory-list"
              sx={{ ...coachCardStyles, display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
              {coach.coach_profile?.sport && <div className="coach-sport-cover"><SportUniverse sport={coach.coach_profile.sport} compact /></div>}
              <CardContent sx={{ p: { xs: 2, md: 3 }, flex: 1, minWidth: 0, "&:last-child": { pb: 2.5 } }}>
                {/* ── HEADER : Avatar + Nom + Sport + Note ── */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 1.2,
                  }}
                >
                  <Box sx={{ position: "relative", flexShrink: 0 }}>
                    <Avatar
                      src={getMediaUrl(coach.coach_profile?.photo) || undefined}
                      alt={coach.username}
                      sx={{
                        width: 52,
                        height: 52,
                        bgcolor: "primary.main",
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        border: "2px solid rgba(184,134,11,0.4)",
                      }}
                    >
                      {coach.username.charAt(0).toUpperCase()}
                    </Avatar>
                    {coach.review_count > 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: -3,
                          right: -3,
                          bgcolor: "#FFD700",
                          borderRadius: "50%",
                          width: 16,
                          height: 16,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Verified sx={{ fontSize: 10, color: "#fff" }} />
                      </Box>
                    )}
                  </Box>
                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.8,
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight={800}
                        sx={{ lineHeight: 1.2 }}
                      >
                        {coach.username}
                      </Typography>
                      {coach.coach_profile?.sport && (
                        <Chip
                          label={tr(coach.coach_profile.sport)}
                          size="small"
                          color="primary"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            fontWeight: 700,
                          }}
                        />
                      )}
                      {coach.coach_profile?.is_itinerant && (
                        <Chip
                          label={tr("🚗 Itinérant")}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            fontWeight: 700,
                            bgcolor: "rgba(25,118,210,0.18)",
                            color: "primary.main",
                            border: "1px solid rgba(25,118,210,0.35)",
                          }}
                        />
                      )}
                    </Box>
                    {coach.avg_rating != null && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.3,
                          mt: 0.2,
                        }}
                      >
                        <Star sx={{ fontSize: 12, color: "#FFD700" }} />
                        <Typography variant="caption" fontWeight={700}>
                          {Number(coach.avg_rating).toFixed(1)}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          ({coach.review_count}  {tr("avis)")} </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* ── BIO ── */}
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    mb: 1.2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {coach.coach_profile?.bio || tr("Aucune bio disponible.")}
                </Typography>

                {/* ── INFOS CLÉS en 2 colonnes ── */}
                <Box
                  sx={{ display: "flex", gap: 2, mb: 1.2, flexWrap: "wrap" }}
                >
                  {coach.coach_profile?.specialties && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "flex", alignItems: "center", gap: 0.4 }}
                    >
                      <SportsScore
                        sx={{ fontSize: 12, color: "primary.main" }}
                      />
                      <span>{coach.coach_profile.specialties}</span>
                    </Typography>
                  )}
                  {(coach.coach_profile?.training_city ||
                    coach.coach_profile?.city ||
                    coach.city) && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "flex", alignItems: "center", gap: 0.4 }}
                    >
                      <LocationOn sx={{ fontSize: 12, color: "#B8860B" }} />
                      <span>
                        {coach.coach_profile?.training_city ||
                          coach.coach_profile?.city ||
                          coach.city}
                        {coach.coach_profile?.postal_code
                          ? ` (${coach.coach_profile.postal_code})`
                          : ""}
                        {coach.coach_profile?.department
                          ? ` · ${coach.coach_profile.department}`
                          : ""}
                      </span>
                    </Typography>
                  )}
                </Box>

                {/* ── RÉSEAUX SOCIAUX ── */}
                {(coach.coach_profile?.social_instagram ||
                  coach.coach_profile?.social_linkedin ||
                  coach.coach_profile?.social_facebook ||
                  coach.coach_profile?.social_website ||
                  coach.coach_profile?.social_tiktok ||
                  coach.coach_profile?.social_x ||
                  coach.coach_profile?.social_snapchat ||
                  coach.coach_profile?.social_youtube ||
                  coach.coach_profile?.social_pinterest ||
                  coach.coach_profile?.social_whatsapp) && (
                  <Stack
                    direction="row"
                    spacing={0.3}
                    sx={{ mb: 1.2, flexWrap: "wrap" }}
                  >
                    {coach.coach_profile?.social_instagram && (
                      <IconButton
                        aria-label={tr("Profil Instagram du coach")}
                        size="small"
                        href={coach.coach_profile.social_instagram}
                        target="_blank"
                        sx={{ p: 0.4, color: "#E1306C" }}
                      >
                        <Instagram sx={{ fontSize: 15 }} />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_tiktok && (
                      <IconButton
                        aria-label={tr("Profil TikTok du coach")}
                        size="small"
                        href={coach.coach_profile.social_tiktok}
                        target="_blank"
                        sx={{ p: 0.4, color: "text.primary" }}
                      >
                        <TikTokIcon />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_x && (
                      <IconButton
                        aria-label={tr("Profil X du coach")}
                        size="small"
                        href={coach.coach_profile.social_x}
                        target="_blank"
                        sx={{ p: 0.4, color: "text.primary" }}
                      >
                        <XIcon />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_snapchat && (
                      <IconButton
                        aria-label={tr("Profil Snapchat du coach")}
                        size="small"
                        href={coach.coach_profile.social_snapchat}
                        target="_blank"
                        sx={{ p: 0.4, color: "#FFFC00" }}
                      >
                        <SnapchatIcon />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_youtube && (
                      <IconButton
                        aria-label={tr("Chaîne YouTube du coach")}
                        size="small"
                        href={coach.coach_profile.social_youtube}
                        target="_blank"
                        sx={{ p: 0.4, color: "#FF0000" }}
                      >
                        <YouTube sx={{ fontSize: 15 }} />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_linkedin && (
                      <IconButton
                        aria-label={tr("Profil LinkedIn du coach")}
                        size="small"
                        href={coach.coach_profile.social_linkedin}
                        target="_blank"
                        sx={{ p: 0.4, color: "#0A66C2" }}
                      >
                        <LinkedIn sx={{ fontSize: 15 }} />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_facebook && (
                      <IconButton
                        aria-label={tr("Page Facebook du coach")}
                        size="small"
                        href={coach.coach_profile.social_facebook}
                        target="_blank"
                        sx={{ p: 0.4, color: "#1877F2" }}
                      >
                        <Facebook sx={{ fontSize: 15 }} />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_pinterest && (
                      <IconButton
                        aria-label={tr("Profil Pinterest du coach")}
                        size="small"
                        href={coach.coach_profile.social_pinterest}
                        target="_blank"
                        sx={{ p: 0.4, color: "#E60023" }}
                      >
                        <Pinterest sx={{ fontSize: 15 }} />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_whatsapp && (
                      <IconButton
                        aria-label={tr("Contacter le coach sur WhatsApp")}
                        size="small"
                        href={`https://wa.me/${coach.coach_profile.social_whatsapp.replace(
                          /[^0-9]/g,
                          ""
                        )}`}
                        target="_blank"
                        sx={{ p: 0.4, color: "#25D366" }}
                      >
                        <WhatsAppIcon />
                      </IconButton>
                    )}
                    {coach.coach_profile?.social_website && (
                      <IconButton
                        aria-label={tr("Site web du coach")}
                        size="small"
                        href={coach.coach_profile.social_website}
                        target="_blank"
                        sx={{ p: 0.4, color: "primary.main" }}
                      >
                        <Language sx={{ fontSize: 15 }} />
                      </IconButton>
                    )}
                  </Stack>
                )}

                {/* ── FOOTER : Tarif + Paiement + Boutons ── */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 2,
                    mt: 2,
                    pt: 2,
                    borderTop: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Box>
                    <Box
                      sx={{ display: "flex", alignItems: "baseline", gap: 0.4 }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight={900}
                        color="primary.main"
                        lineHeight={1}
                      >
                        {coach.coach_profile?.hourly_rate ?? "—"} €
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        /h
                      </Typography>
                    </Box>
                    {coach.coach_profile?.payment_methods && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.3,
                          mt: 0.2,
                        }}
                      >
                        💳 {coach.coach_profile.payment_methods}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleViewCoach(coach)}
                      sx={{
                        fontWeight: 700,
                        borderRadius: 2,
                        px: 2,
                        background:
                          "linear-gradient(135deg, rgba(25,118,210,0.55) 0%, rgba(184,134,11,0.45) 100%)",
                        border: "1px solid rgba(184,134,11,0.6)",
                        color: "#fff",
                        backdropFilter: "blur(6px)",
                        boxShadow: "0 2px 12px rgba(184,134,11,0.25)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(25,118,210,0.75) 0%, rgba(184,134,11,0.65) 100%)",
                          boxShadow: "0 4px 18px rgba(184,134,11,0.4)",
                        },
                      }}
                    >
                      {visitor ? tr("Voir le profil") : tr("Réserver")}
                    </Button>
                    <IconButton
                      aria-label={tr("Ouvrir la conversation")}
                      size="small"
                      onClick={() =>
                        visitor ? registerForCoach(coach) : navigate("/messages", {
                          state: { recipient: coach, roleMode: "SPORTIF" },
                        })
                      }
                      title={tr("Message")}
                      color="primary"
                      sx={{
                        border: "1px solid",
                        borderColor: "primary.main",
                        borderRadius: 1.5,
                      }}
                    >
                      <Chat fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : (
        /* ── VUE GRILLE ── */
        <Grid container spacing={3}>
          {coaches.map((coach) => (
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }} key={coach.id}>
              <Card className="coach-directory-card coach-directory-grid" sx={{ ...coachCardStyles, height: '100%', display: 'flex', flexDirection: 'column' }}>
                {coach.coach_profile?.sport && <div className="coach-sport-cover"><SportUniverse sport={coach.coach_profile.sport} compact /></div>}
                <CardContent sx={{ flexGrow: 1, p: 2.5 }}>
                  {/* Avatar + Nom + Sport */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      mb: 2,
                      alignItems: "flex-start",
                    }}
                  >
                    <Box sx={{ position: "relative" }}>
                      <Avatar
                        src={
                          getMediaUrl(coach.coach_profile?.photo) || undefined
                        }
                        alt={coach.username}
                        sx={{
                          width: 64,
                          height: 64,
                          bgcolor: "primary.main",
                          fontSize: "1.6rem",
                          fontWeight: "bold",
                          boxShadow: 3,
                        }}
                      >
                        {coach.username.charAt(0).toUpperCase()}
                      </Avatar>
                      {coach.review_count > 0 && (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: -4,
                            right: -4,
                            bgcolor: "#FFD700",
                            borderRadius: "50%",
                            width: 22,
                            height: 22,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: 1,
                          }}
                        >
                          <Verified sx={{ fontSize: 14, color: "#fff" }} />
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 800,
                          lineHeight: 1.2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {coach.username}
                      </Typography>
                      {coach.coach_profile?.sport && (
                        <Chip
                          label={tr(coach.coach_profile.sport)}
                          size="small"
                          color="primary"
                          sx={{
                            height: 20,
                            fontSize: "0.68rem",
                            mt: 0.5,
                            fontWeight: 700,
                          }}
                        />
                      )}
                      {/* Rating */}
                      {coach.avg_rating != null && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.4,
                            mt: 0.5,
                          }}
                        >
                          <Star sx={{ fontSize: 14, color: "#FFD700" }} />
                          <Typography variant="caption" fontWeight={700}>
                            {Number(coach.avg_rating).toFixed(1)}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            ({coach.review_count}  {tr("avis)")} </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>

                  {/* Bio */}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mb: 2,
                      minHeight: 36,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      lineHeight: 1.5,
                    }}
                  >
                    {coach.coach_profile?.bio || tr("Aucune bio disponible.")}
                  </Typography>

                  {/* Spécialités */}
                  {coach.coach_profile?.specialties && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mb: 1,
                      }}
                    >
                      <SportsScore
                        sx={{ fontSize: 14, color: "text.secondary" }}
                      />
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                      >
                        {coach.coach_profile.specialties}
                      </Typography>
                    </Box>
                  )}

                  {/* Expérience */}
                  {coach.coach_profile?.experience && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mb: 1,
                      }}
                    >
                      <Work sx={{ fontSize: 14, color: "text.secondary" }} />
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                      >
                        {coach.coach_profile.experience}
                      </Typography>
                    </Box>
                  )}

                  {/* Localisation */}
                  {(coach.coach_profile?.training_city ||
                    coach.coach_profile?.city ||
                    coach.city) && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mb: 0.5,
                      }}
                    >
                      <LocationOn
                        sx={{ fontSize: 14, color: "text.secondary" }}
                      />
                      <Typography variant="caption" color="text.secondary">
                        {coach.coach_profile?.training_city ||
                          coach.coach_profile?.city ||
                          coach.city}
                        {coach.coach_profile?.postal_code
                          ? ` (${coach.coach_profile.postal_code})`
                          : ""}
                        {coach.coach_profile?.department
                          ? ` — ${coach.coach_profile.department}`
                          : coach.department
                          ? ` — ${coach.department}`
                          : ""}
                      </Typography>
                    </Box>
                  )}
                  {coach.coach_profile?.is_itinerant && (
                    <Box sx={{ mb: 1 }}>
                      <Chip
                        label={tr("🚗 Coach itinérant")}
                        size="small"
                        sx={{
                          height: 18,
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          bgcolor: "rgba(25,118,210,0.15)",
                          color: "primary.main",
                          border: "1px solid rgba(25,118,210,0.3)",
                        }}
                      />
                    </Box>
                  )}

                  {/* Réseaux sociaux vue grille */}
                  {(coach.coach_profile?.social_instagram ||
                    coach.coach_profile?.social_linkedin ||
                    coach.coach_profile?.social_facebook ||
                    coach.coach_profile?.social_website ||
                    coach.coach_profile?.social_tiktok ||
                    coach.coach_profile?.social_x ||
                    coach.coach_profile?.social_snapchat ||
                    coach.coach_profile?.social_youtube ||
                    coach.coach_profile?.social_pinterest ||
                    coach.coach_profile?.social_whatsapp) && (
                    <Stack
                      direction="row"
                      spacing={0.5}
                      sx={{ mb: 1.5, flexWrap: "wrap" }}
                    >
                      {coach.coach_profile?.social_instagram && (
                        <IconButton
                          aria-label={tr("Profil Instagram du coach")}
                          size="small"
                          href={coach.coach_profile.social_instagram}
                          target="_blank"
                          sx={{ p: 0.5, color: "#E1306C" }}
                        >
                          <Instagram sx={{ fontSize: 16 }} />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_tiktok && (
                        <IconButton
                          aria-label={tr("Profil TikTok du coach")}
                          size="small"
                          href={coach.coach_profile.social_tiktok}
                          target="_blank"
                          sx={{ p: 0.5, color: "text.primary" }}
                        >
                          <TikTokIcon />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_x && (
                        <IconButton
                          aria-label={tr("Profil X du coach")}
                          size="small"
                          href={coach.coach_profile.social_x}
                          target="_blank"
                          sx={{ p: 0.5, color: "text.primary" }}
                        >
                          <XIcon />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_snapchat && (
                        <IconButton
                          aria-label={tr("Profil Snapchat du coach")}
                          size="small"
                          href={coach.coach_profile.social_snapchat}
                          target="_blank"
                          sx={{ p: 0.5, color: "#FFFC00" }}
                        >
                          <SnapchatIcon />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_youtube && (
                        <IconButton
                          aria-label={tr("Chaîne YouTube du coach")}
                          size="small"
                          href={coach.coach_profile.social_youtube}
                          target="_blank"
                          sx={{ p: 0.5, color: "#FF0000" }}
                        >
                          <YouTube sx={{ fontSize: 16 }} />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_linkedin && (
                        <IconButton
                          aria-label={tr("Profil LinkedIn du coach")}
                          size="small"
                          href={coach.coach_profile.social_linkedin}
                          target="_blank"
                          sx={{ p: 0.5, color: "#0A66C2" }}
                        >
                          <LinkedIn sx={{ fontSize: 16 }} />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_facebook && (
                        <IconButton
                          aria-label={tr("Page Facebook du coach")}
                          size="small"
                          href={coach.coach_profile.social_facebook}
                          target="_blank"
                          sx={{ p: 0.5, color: "#1877F2" }}
                        >
                          <Facebook sx={{ fontSize: 16 }} />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_pinterest && (
                        <IconButton
                          aria-label={tr("Profil Pinterest du coach")}
                          size="small"
                          href={coach.coach_profile.social_pinterest}
                          target="_blank"
                          sx={{ p: 0.5, color: "#E60023" }}
                        >
                          <Pinterest sx={{ fontSize: 16 }} />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_whatsapp && (
                        <IconButton
                          aria-label={tr("Contacter le coach sur WhatsApp")}
                          size="small"
                          href={`https://wa.me/${coach.coach_profile.social_whatsapp.replace(
                            /[^0-9]/g,
                            ""
                          )}`}
                          target="_blank"
                          sx={{ p: 0.5, color: "#25D366" }}
                        >
                          <WhatsAppIcon />
                        </IconButton>
                      )}
                      {coach.coach_profile?.social_website && (
                        <IconButton
                          aria-label={tr("Site web du coach")}
                          size="small"
                          href={coach.coach_profile.social_website}
                          target="_blank"
                          sx={{ p: 0.5, color: "primary.main" }}
                        >
                          <Language sx={{ fontSize: 16 }} />
                        </IconButton>
                      )}
                    </Stack>
                  )}

                  {/* Tarif */}
                  <Box
                    sx={{
                      mt: "auto",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 1.5,
                      bgcolor: "primary.main",
                      borderRadius: 2,
                      background:
                        "linear-gradient(135deg, rgba(25,118,210,0.15), rgba(66,165,245,0.1))",
                      border: "1px solid",
                      borderColor: "primary.light",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 900,
                          color: "primary.main",
                          lineHeight: 1,
                        }}
                      >
                        {coach.coach_profile?.hourly_rate ?? "—"} €
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                         {tr("tarif / heure")} </Typography>
                    </Box>
                    {coach.coach_profile?.payment_methods && (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <Euro sx={{ fontSize: 14, color: "text.secondary" }} />
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            maxWidth: 80,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {coach.coach_profile.payment_methods}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </CardContent>

                <CardActions sx={{ px: 2, pb: 2, pt: 0, gap: 1 }}>
                  <Button
                    variant="contained"
                    onClick={() => handleViewCoach(coach)}
                    fullWidth
                    sx={{
                      fontWeight: 700,
                      borderRadius: 2,
                      background:
                        "linear-gradient(135deg, rgba(25,118,210,0.55) 0%, rgba(184,134,11,0.45) 100%)",
                      border: "1px solid rgba(184,134,11,0.6)",
                      color: "#fff",
                      backdropFilter: "blur(6px)",
                      boxShadow: "0 2px 12px rgba(184,134,11,0.25)",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, rgba(25,118,210,0.75) 0%, rgba(184,134,11,0.65) 100%)",
                        boxShadow: "0 4px 18px rgba(184,134,11,0.4)",
                      },
                    }}
                  >
                    {visitor ? tr("Voir le profil") : tr("Réserver")}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() =>
                      visitor ? registerForCoach(coach) : navigate("/messages", {
                        state: { recipient: coach, roleMode: "SPORTIF" },
                      })
                    }
                    sx={{ minWidth: 44, px: 1.5, borderRadius: 2 }}
                    title={tr("Envoyer un message")}
                  >
                    <Chat fontSize="small" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {totalCount > PAGE_SIZE && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Pagination
            count={Math.ceil(totalCount / PAGE_SIZE)}
            page={page}
            onChange={(_, p) => {
              setPage(p);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            color="primary"
            shape="rounded"
          />
        </Box>
      )}

      {/* Main Reservation Dialog */}
      <PublicCoachDetails coach={publicCoach} onClose={() => setPublicCoach(null)} onRegister={() => registerForCoach(publicCoach)} />
      <Dialog
        open={openBooking}
        onClose={() => setOpenBooking(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            background:
              "linear-gradient(160deg, rgba(255,255,255,0.10) 0%, rgba(20,20,40,0.97) 40%, rgba(184,134,11,0.08) 100%)",
            backdropFilter: "blur(24px) saturate(180%)",
            WebkitBackdropFilter: "blur(24px) saturate(180%)",
            border: "1px solid rgba(184,134,11,0.45)",
            boxShadow:
              "0 8px 40px rgba(0,0,0,0.6), inset 0 2px 0 rgba(255,255,255,0.12), inset 0 -1px 0 rgba(184,134,11,0.2)",
            borderRadius: isMobile ? 0 : 3,
            position: "relative",
            overflow: "hidden",
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: "10%",
              right: "10%",
              height: "2px",
              background:
                "linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)",
              borderRadius: "0 0 50% 50%",
              pointerEvents: "none",
            },
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid rgba(184,134,11,0.3)",
            pb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
           {tr("Réserver une séance")} {isMobile && (
            <IconButton
              aria-label={tr("Fermer")}
              edge="end"
              color="inherit"
              onClick={() => setOpenBooking(false)}
            >
              <Close />
            </IconButton>
          )}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          {message && (
            <Alert
              severity="success"
              sx={{ mb: 2 }}
              onClose={() => setMessage("")}
            >
              {tr(message)}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
              {typeof error === 'string' ? tr(error) : error}
            </Alert>
          )}
          {/* Enhanced Coach Info */}
          {selectedCoach && (
            <Box
              sx={{
                mb: 4,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                bgcolor: "action.hover",
                p: 2,
                borderRadius: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <Avatar
                  src={
                    getMediaUrl(selectedCoach.coach_profile?.photo) || undefined
                  }
                  alt={selectedCoach.username}
                  sx={{
                    width: 64,
                    height: 64,
                    bgcolor: "primary.main",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                  }}
                >
                  {selectedCoach.username.charAt(0).toUpperCase()}
                </Avatar>
                <Box>
                  <Typography variant="h6" fontWeight="bold">
                    {selectedCoach.username}
                  </Typography>
                  <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                    <Chip
                      icon={<SportsScore sx={{ fontSize: 16 }} />}
                      label={selectedCoach.coach_profile?.sport || tr("Coach")}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                    <Chip
                      icon={<Euro sx={{ fontSize: 16 }} />}
                      label={`${
                        selectedCoach.coach_profile?.hourly_rate || 0
                      }€/h`}
                      size="small"
                      variant="outlined"
                    />
                  </Stack>
                </Box>
              </Box>

              <Divider />

              {/* Extended Details */}
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  <strong>{tr("Bio:")}</strong>{" "}
                  {selectedCoach.coach_profile?.bio || tr("Non renseigné")}
                </Typography>
                {(selectedCoach.coach_profile?.training_city ||
                  selectedCoach.coach_profile?.city) && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                    sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                  >
                    <LocationOn sx={{ fontSize: 14 }} />
                    <span>
                      <strong>{tr("Zone d'entraînement :")}</strong>{" "}
                      {selectedCoach.coach_profile?.training_city ||
                        selectedCoach.coach_profile?.city}
                      {selectedCoach.coach_profile?.postal_code
                        ? ` (${selectedCoach.coach_profile.postal_code})`
                        : ""}
                      {selectedCoach.coach_profile?.department
                        ? ` — ${selectedCoach.coach_profile.department}`
                        : ""}
                    </span>
                  </Typography>
                )}
                {selectedCoach.coach_profile?.is_itinerant && (
                  <Box sx={{ mb: 1 }}>
                    <Chip
                      label={tr("🚗 Coach itinérant — se déplace chez vous")}
                      size="small"
                      sx={{
                        fontWeight: 700,
                        bgcolor: "rgba(25,118,210,0.15)",
                        color: "primary.main",
                        border: "1px solid rgba(25,118,210,0.3)",
                      }}
                    />
                  </Box>
                )}
                {selectedCoach.coach_profile?.specialties && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    <strong>{tr("Spécialités:")}</strong>{" "}
                    {selectedCoach.coach_profile.specialties}
                  </Typography>
                )}
                {selectedCoach.coach_profile?.diplomas && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    <strong>{tr("Diplômes:")}</strong>{" "}
                    {selectedCoach.coach_profile.diplomas}
                  </Typography>
                )}
                {selectedCoach.coach_profile?.experience && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    <strong>{tr("Expérience:")}</strong>{" "}
                    {selectedCoach.coach_profile.experience}
                  </Typography>
                )}

                {/* Socials in Modal */}
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{ mt: 1, flexWrap: "wrap" }}
                >
                  {selectedCoach.coach_profile?.social_instagram && (
                    <IconButton
                      aria-label={tr("Profil Instagram du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_instagram}
                      target="_blank"
                      sx={{ color: "#E1306C" }}
                    >
                      <Instagram fontSize="small" />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_tiktok && (
                    <IconButton
                      aria-label={tr("Profil TikTok du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_tiktok}
                      target="_blank"
                      sx={{ color: "text.primary" }}
                    >
                      <TikTokIcon />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_x && (
                    <IconButton
                      aria-label={tr("Profil X du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_x}
                      target="_blank"
                      sx={{ color: "text.primary" }}
                    >
                      <XIcon />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_snapchat && (
                    <IconButton
                      aria-label={tr("Profil Snapchat du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_snapchat}
                      target="_blank"
                      sx={{ color: "#FFFC00" }}
                    >
                      <SnapchatIcon />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_youtube && (
                    <IconButton
                      aria-label={tr("Chaîne YouTube du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_youtube}
                      target="_blank"
                      sx={{ color: "#FF0000" }}
                    >
                      <YouTube fontSize="small" />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_linkedin && (
                    <IconButton
                      aria-label={tr("Profil LinkedIn du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_linkedin}
                      target="_blank"
                      sx={{ color: "#0A66C2" }}
                    >
                      <LinkedIn fontSize="small" />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_facebook && (
                    <IconButton
                      aria-label={tr("Page Facebook du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_facebook}
                      target="_blank"
                      sx={{ color: "#1877F2" }}
                    >
                      <Facebook fontSize="small" />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_pinterest && (
                    <IconButton
                      aria-label={tr("Profil Pinterest du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_pinterest}
                      target="_blank"
                      sx={{ color: "#E60023" }}
                    >
                      <Pinterest fontSize="small" />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_whatsapp && (
                    <IconButton
                      aria-label={tr("Contacter le coach sur WhatsApp")}
                      size="small"
                      href={`https://wa.me/${selectedCoach.coach_profile.social_whatsapp.replace(
                        /[^0-9]/g,
                        ""
                      )}`}
                      target="_blank"
                      sx={{ color: "#25D366" }}
                    >
                      <WhatsAppIcon />
                    </IconButton>
                  )}
                  {selectedCoach.coach_profile?.social_website && (
                    <IconButton
                      aria-label={tr("Site web du coach")}
                      size="small"
                      href={selectedCoach.coach_profile.social_website}
                      target="_blank"
                      sx={{ color: "primary.main" }}
                    >
                      <Language fontSize="small" />
                    </IconButton>
                  )}
                </Stack>
                {selectedCoach.coach_profile?.payment_methods && (
                  <Box
                    sx={{
                      mt: 2,
                      p: 1.5,
                      bgcolor: "action.hover",
                      borderRadius: 2,
                      border: "1px solid rgba(184,134,11,0.3)",
                    }}
                  >
                    <Typography
                      variant="caption"
                      fontWeight={700}
                      color="text.primary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mb: 0.3,
                      }}
                    >
                       {tr("💳 Modalités de paiement")} </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ whiteSpace: "pre-line" }}
                    >
                      {selectedCoach.coach_profile.payment_methods}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          )}

          {/* Program Selection */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
               {tr("1. Choisir un programme (optionnel)")} </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <FormControl fullWidth size="small">
                <InputLabel id="program-label">{tr("Programme")}</InputLabel>
                <Select
                  labelId="program-label"
                  value={selectedProgramId}
                  label={tr("Programme")}
                  onChange={(e) => setSelectedProgramId(e.target.value as any)}
                >
                  <MenuItem value="">{tr("Aucun programme (Séance libre)")}</MenuItem>
                  {programs.map((p) => (
                    <MenuItem key={p.id} value={p.id}>
                      {p.title} - {p.price} €
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="outlined"
                startIcon={<Info />}
                disabled={!selectedProgramId}
                onClick={handleOpenProgramDetails}
                sx={{ whiteSpace: "nowrap" }}
              >
                 {tr("Détails")} </Button>
            </Stack>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Séances déjà planifiées par le coach pour ce sportif */}
          {myBookings.filter(
            (b) =>
              b.status !== "CANCELLED" && new Date(b.start_time) > new Date()
          ).length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                gutterBottom
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                 {tr("📅 Séances planifiées pour vous")} </Typography>
              <List sx={{ bgcolor: "action.hover", borderRadius: 2, p: 0 }}>
                {myBookings
                  .filter(
                    (b) =>
                      b.status !== "CANCELLED" &&
                      new Date(b.start_time) > new Date()
                  )
                  .sort(
                    (a, b) =>
                      new Date(a.start_time).getTime() -
                      new Date(b.start_time).getTime()
                  )
                  .map((bk) => {
                    const chipLabel =
                      bk.status === "PENDING"
                        ? "⏳ En attente"
                        : bk.status === "CONFIRMED"
                        ? "✓ Confirmé"
                        : bk.status === "COMPLETED"
                        ? "Terminé"
                        : "Annulé";
                    const chipColor =
                      bk.status === "PENDING"
                        ? "#B45309"
                        : bk.status === "CONFIRMED"
                        ? "#3B82F6"
                        : bk.status === "COMPLETED"
                        ? "#10B981"
                        : "#EF4444";
                    return (
                      <ListItem key={bk.id} divider sx={{ px: 2, py: 1.5 }}>
                        <Box
                          sx={{
                            display: "flex",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                            }}
                          >
                            <AccessTime
                              sx={{ color: "text.secondary", fontSize: 18 }}
                            />
                            <Box>
                              <Typography
                                variant="body2"
                                fontWeight={700}
                                sx={{ textTransform: "capitalize" }}
                              >
                                {format(
                                  new Date(bk.start_time),
                                  "EEEE d MMMM yyyy",
                                  { locale: dateLocale }
                                )}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {format(new Date(bk.start_time), "HH:mm")} →{" "}
                                {format(new Date(bk.end_time), "HH:mm")}
                                {bk.program_details?.title &&
                                  ` · ${bk.program_details.title}`}
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Chip
                              label={chipLabel}
                              size="small"
                              sx={{
                                bgcolor: `${chipColor}22`,
                                color: chipColor,
                                fontWeight: 700,
                                fontSize: "0.7rem",
                                border: `1px solid ${chipColor}55`,
                              }}
                            />
                            {bk.status === "PENDING" && (
                              <Button
                                size="small"
                                variant="outlined"
                                color="error"
                                sx={{
                                  fontSize: "0.7rem",
                                  py: 0.3,
                                  px: 1,
                                  minWidth: 0,
                                }}
                                onClick={() => handleSportifCancel(bk.id)}
                              >
                                 {tr("Annuler")} </Button>
                            )}
                          </Box>
                        </Box>
                      </ListItem>
                    );
                  })}
              </List>
              <Divider sx={{ mt: 3, mb: 2 }} />
            </Box>
          )}

          {/* Slot Selection */}
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
               {tr("2. Choisir un créneau disponible")} </Typography>
            <List
              sx={{
                bgcolor: "background.paper",
                border: "1px solid #eee",
                borderRadius: 1,
                maxHeight: 300,
                overflow: "auto",
              }}
            >
              {(() => {
                const bookedSlotTimes = new Set(
                  myBookings
                    .filter(
                      (b) => b.status === "PENDING" || b.status === "CONFIRMED"
                    )
                    .map((b) => b.start_time)
                );
                const freeSlots = availabilities
                  .filter(
                    (slot) =>
                      !slot.is_booked &&
                      new Date(slot.start_time) > new Date() &&
                      !bookedSlotTimes.has(slot.start_time)
                  )
                  .sort(
                    (a, b) =>
                      new Date(a.start_time).getTime() -
                      new Date(b.start_time).getTime()
                  );
                if (freeSlots.length === 0)
                  return (
                    <Box sx={{ textAlign: "center", py: 3, px: 2 }}>
                      <AccessTime
                        sx={{ fontSize: 40, color: "text.disabled", mb: 1 }}
                      />
                      <Typography variant="body2" fontWeight={700} gutterBottom>
                         {tr("Aucun créneau disponible pour le moment")} </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mb: 2 }}
                      >
                         {tr("Ce coach n'a pas de créneau ouvert, ou vous les avez déjà tous réservés. Contactez-le directement pour convenir d'une date.")} </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Chat />}
                        onClick={() => {
                          setOpenBooking(false);
                          navigate("/messages", {
                            state: {
                              recipient: selectedCoach,
                              roleMode: "SPORTIF",
                            },
                          });
                        }}
                      >
                         {tr("Contacter le coach")} </Button>
                    </Box>
                  );
                return freeSlots.map((slot) => (
                  <ListItem key={slot.id} divider sx={{ px: 2, py: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <AccessTime color="action" />
                        <ListItemText
                          primary={format(
                            new Date(slot.start_time),
                            "EEEE d MMMM",
                            { locale: dateLocale }
                          )}
                          secondary={`${format(
                            new Date(slot.start_time),
                            "HH:mm"
                          )} - ${format(new Date(slot.end_time), "HH:mm")}`}
                          primaryTypographyProps={{
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        />
                      </Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {slot.max_participants > 1 && (
                          <Chip
                            icon={<People sx={{ fontSize: 14 }} />}
                            label={`${
                              slot.max_participants - (slot.booking_count ?? 0)
                            } place${
                              slot.max_participants -
                                (slot.booking_count ?? 0) >
                              1
                                ? "s"
                                : ""
                            }`}
                            size="small"
                            sx={{ fontSize: "0.7rem", height: 22 }}
                            color={
                              slot.max_participants -
                                (slot.booking_count ?? 0) <=
                              1
                                ? "warning"
                                : "default"
                            }
                          />
                        )}
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleBookSession(slot.id)}
                          disabled={bookingSlotId !== null}
                          startIcon={
                            bookingSlotId === slot.id ? (
                              <CircularProgress size={16} color="inherit" />
                            ) : undefined
                          }
                          sx={{ fontWeight: 700, minWidth: 116 }}
                        >
                          {bookingSlotId === slot.id
                            ? tr("Réservation…")
                            : tr("Réserver")}
                        </Button>
                      </Box>
                    </Box>
                  </ListItem>
                ));
              })()}
            </List>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ p: 2, pt: 0, display: "flex", justifyContent: "space-between" }}
        >
          <Button
            onClick={() => {
              setOpenBooking(false);
              navigate("/messages", {
                state: { recipient: selectedCoach, roleMode: "SPORTIF" },
              });
            }}
            startIcon={<Chat />}
            color="primary"
          >
             {tr("Message")} </Button>
          {!isMobile && (
            <Box>
              <Button
                onClick={() => setOpenBooking(false)}
                color="inherit"
                sx={{ mr: 1 }}
              >
                 {tr("Annuler")} </Button>
            </Box>
          )}
        </DialogActions>
      </Dialog>

      {/* Program Details Dialog */}
      <Dialog
        open={openProgramDetails}
        onClose={() => setOpenProgramDetails(false)}
        fullScreen={isMobile}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {programToView?.title}
          {isMobile && (
            <IconButton
              aria-label={tr("Fermer")}
              edge="end"
              color="inherit"
              onClick={() => setOpenProgramDetails(false)}
            >
              <Close />
            </IconButton>
          )}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ minWidth: isMobile ? "auto" : 300, py: 1 }}>
            <Typography
              variant="h4"
              color="primary"
              gutterBottom
              fontWeight="bold"
            >
              {programToView?.price} €
            </Typography>
            <Typography
              variant="body1"
              sx={{ whiteSpace: "pre-line", lineHeight: 1.6 }}
            >
              {programToView?.description}
            </Typography>
            {selectedCoach?.coach_profile?.payment_methods && (
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  bgcolor: "action.hover",
                  borderRadius: 2,
                  border: "1px solid rgba(184,134,11,0.3)",
                }}
              >
                <Typography
                  variant="caption"
                  fontWeight={700}
                  color="text.primary"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 0.5,
                  }}
                >
                   {tr("💳 Modalités de paiement")} </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ whiteSpace: "pre-line" }}
                >
                  {selectedCoach.coach_profile.payment_methods}
                </Typography>
              </Box>
            )}
            <Box sx={{ mt: 2, p: 2, bgcolor: "action.hover", borderRadius: 2 }}>
              <Typography variant="caption" color="text.secondary">
                 {tr("En sélectionnant ce programme, le tarif ci-dessus s'appliquera à votre réservation.")} </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenProgramDetails(false)}>{tr("Fermer")}</Button>
        </DialogActions>
      </Dialog>

      {/* Récapitulatif de réservation */}
      <Dialog
        open={Boolean(bookingConfirmation)}
        onClose={() => setBookingConfirmation(null)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{ display: "flex", alignItems: "center", gap: 1.5, pr: 5 }}
        >
          <Verified color="success" />
          <Box component="span" sx={{ fontWeight: 800 }}>
             {tr("Demande envoyée !")} </Box>
          <IconButton
            aria-label={tr("Fermer")}
            onClick={() => setBookingConfirmation(null)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {bookingConfirmation && (
            <Stack spacing={1.5}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <SportsScore color="primary" />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                     {tr("Coach")} </Typography>
                  <Typography fontWeight={700}>
                    {bookingConfirmation.coachName}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <AccessTime color="primary" />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                     {tr("Date & heure")} </Typography>
                  <Typography
                    fontWeight={700}
                    sx={{ textTransform: "capitalize" }}
                  >
                    {format(
                      new Date(bookingConfirmation.start),
                      "EEEE d MMMM",
                      { locale: dateLocale }
                    )}
                    {" · "}
                    {format(
                      new Date(bookingConfirmation.start),
                      "HH:mm"
                    )} – {format(new Date(bookingConfirmation.end), "HH:mm")}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Euro color="primary" />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {bookingConfirmation.programTitle}
                  </Typography>
                  <Typography fontWeight={700}>
                    {bookingConfirmation.price
                      ? `${bookingConfirmation.price} €`
                      : tr("Tarif à confirmer")}
                  </Typography>
                </Box>
              </Box>
              <Alert severity="info" sx={{ mt: 1 }}>
                 {tr("Votre demande est")} <strong>{tr("en attente de confirmation")}</strong>{" "}
                 {tr("par le coach. Vous recevrez un email dès qu'il l'aura acceptée. Le règlement se fait directement auprès du coach.")} </Alert>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => setBookingConfirmation(null)}
          >
             {tr("J'ai compris")} </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CoachList;
